import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";

export interface RetroIntento {
  id: number;
  /** Número del intento como lo ve el aprendiz (1 = el primero). */
  numero: number;
  creadoEl: string;
  archivoNombre: string | null;
  retro: string;
}

/** Retroalimentaciones de todos los intentos de una actividad, en orden cronológico. */
export function useRetrosActividad(idActividadAprendiz: number | undefined) {
  return useQuery({
    queryKey: ["retrosActividad", idActividadAprendiz],
    queryFn: async () => {
      const res = await axiosInstance.get<RetroIntento[]>(
        `/intentos/actividad-aprendiz/${idActividadAprendiz}`,
      );
      return res.data;
    },
    enabled: !!idActividadAprendiz,
  });
}
